import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Heading, Pane } from 'evergreen-ui';
import { deleteShortUrl, getShortUrl } from '../actions/ShortUrlActions';

import { Link } from 'react-router-dom';
import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import ShortUrlInfoBlock from '../components/ShortUrlInfoBlock';

class ViewShortUrl extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }

    async componentDidMount() {
        await this.props.dispatch(getShortUrl(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deleteShortUrl(this.id));
    }

    render() {

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/short-urls">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista short URLs
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge short url"
                            title="Confirmare stergere short url"
                            confirmLabel="Sterg definitiv short url"
                            message="Esti sigur ca vrei sa stergi short url-ul?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Short URL - <strong>{this.props.shortUrl.name}</strong>
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <ShortUrlInfoBlock shortUrl={this.props.shortUrl}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        shortUrl: state.shortUrls.current
    }
}

export default connect(mapStateToProps)(ViewShortUrl);
